import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NullableString } from '@app/shared/models/nullable';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContactInfoComponent implements OnInit {
  @Input() showFooterText = true;
  public gasLabel: NullableString = null;
  public gasNumber: NullableString = null;
  public showContactDetails!: boolean;
  public showGasDetails!: boolean;
  public showContactFootnote: boolean = false;

  constructor(private translate: TranslateService) {}

  public ngOnInit(): void {
    const gasLabelPath = 'module.contact.faultNumberGas';
    this.translate
      .get(gasLabelPath)
      .pipe(first())
      .subscribe((t) => {
        if (t !== gasLabelPath) {
          this.gasLabel = t;
        }
      });

    const gasNumberPath = 'module.contact.telephoneGas';
    this.translate
      .get(gasNumberPath)
      .pipe(first())
      .subscribe((t) => {
        if (t !== gasNumberPath) {
          this.gasNumber = t;
        }
      });

    this.showContactDetails = environment.tenant !== 'edis';
    this.showGasDetails = environment.tenant !== 'shn';
    this.showContactFootnote = environment.tenant === 'edis';
  }

  public mailer(): void {
    this.translate
      .get('module.contact.email')
      .pipe(first())
      .subscribe((value) => {
        const mail = value;
        window.location.href = `mailto:${mail}`;
      });
  }
}
